<div class="a-upload-wrapper">
  <div class="uploaded" *ngIf="isFilesUploaded==true; else uploadTemplate" ad-upload-area
    (onSelect)="onFileSelected($event)" applyHoverStyle="true" [auto]="false" [disabled]="disabled"
    [ngClass]="{'upload-borde':isMoving}">
    <div class="file" *ngFor="let file of files;let last=last">
      <span class="file-name">{{file.fileName}}</span>
      <i class="fa fa-trash dsf-clickable" [ngClass]="{'dsf-disabled':isFileDeletable(file)}"
        (click)="removeFile(file)"></i>
      <i class="fa fa-plus dsf-clickable" *ngIf="last" [ngClass]="{'dsf-disabled':disabled}" [ad-upload]
        [accept]="accept" [disabled]="disabled" (onSelect)="onFileSelected($event)"></i>
    </div>
  </div>
  <ng-template #uploadTemplate>
    <div class="upload-area flex-center upload-border" ad-upload-area (onSelect)="onFileSelected($event)" [auto]="false"
      [disabled]="disabled">
      <div class="upload-content">
        <span class="heading-8"><i class="fa fa-upload"></i> Drag and drop files here</span>
        <span style="font-weight: 600;margin:auto 20px;">OR</span>
        <p-button type="button" styleClass="ui-button-secondary wide-padding a-corner-all" [ad-upload] label="Browse"
          [style]="{'padding-left':'40px','padding-right':'40px','height':'38px'}" [auto]="false" [accept]="accept"
          [disabled]="disabled" (onSelect)="onFileSelected($event)">
        </p-button>
      </div>
    </div>
  </ng-template>
</div>